import { position } from 'app/analytics/selectors';
import translations from 'app/features/localization/translations.json';
import {
  skuSelected,
  freeTrialSelected,
  subscriptionSelected,
  subscriptionRequested,
  skipFreeTrialSet,
} from 'app/features/products/actions';
import {
  isSelectedProductWithOnePlan,
  productPlanSku,
  freeTrialDurationDays,
} from 'app/features/products/selectors';
import { isDirectToPay } from 'app/features/user/selectors';
import { isMigrationCouponFlow } from 'app/features/migration/landing/selectors';
import { getOfferId } from 'app/router/selectors';

const dispatchSubscriptionEvents = (dispatch, getState, props) => {
  const state = getState();

  const eventPayload = {
    sku: productPlanSku(state, props),
    position: position(state, props),
    textOfButtonOrLink: translations[props.textKey],
  };

  dispatch(subscriptionSelected(eventPayload));

  if (isSelectedProductWithOnePlan(state, props)) {
    dispatch(subscriptionRequested(eventPayload));
  }
};

const productCtaClicked = props => (dispatch, getState) => {
  const { sku, lengthOfFreeTrial } = props;
  const state = getState();
  const shouldTrackAsSubscription =
    isDirectToPay(state) &&
    (getOfferId(state) || !isMigrationCouponFlow(state));

  dispatch(skuSelected(sku));

  if (shouldTrackAsSubscription) {
    dispatchSubscriptionEvents(dispatch, getState, props);
  } else {
    const eventPayload = {
      sku,
      lengthOfFreeTrial,
      position: position(state, props),
      textOfButtonOrLink:
        translations[props.textKey] &&
        translations[props.textKey].replace(
          '{days}',
          freeTrialDurationDays(state),
        ),
    };

    dispatch(freeTrialSelected(eventPayload));
  }
};

const skipFreeTrialClicked = props => (dispatch, getState) => {
  const { sku } = props;

  dispatch(skipFreeTrialSet());
  dispatch(skuSelected(sku));

  dispatchSubscriptionEvents(dispatch, getState, props);
};

export { skipFreeTrialClicked, productCtaClicked };
